<template>
  <section   class="section section_bg main_page_content first_page">
    <loading-block v-if="is_load==false" :loading="!is_load"/>

    <div class="container-fluid">



            <div class="row second_section">
              <div class="col-12 col-md-5 col-lg-5">

                <v-lazy-image v-if="item.photos[current_pic]" class="img img-thumbnail" :src="item.photos[current_pic]"/>
                <div class="row d-flex justify-content-center">
                  <button v-if="show_prev_btn" @click="showNextPic('minus')"class="btn"><</button>
                  <button v-if="show_next_btn" @click="showNextPic('plus')" class="btn">> </button>
                </div>
              </div>

              <div class="col-12 col-md-6 col-lg-6">
                <h2>  {{ item.title}}</h2>
                <p v-if="item.variants && item.variants.length>0">
                  <select  class="form-control" v-model="current_variant">
                    <option  v-for="(variant,variant_key) in item.variants" :value="variant_key">{{ variant.title }}</option>
                  </select>
                </p>
                <p><b>Категория</b>:<router-link tag="a" :to="{name: 'shop_categorys', query: { category_id: category.last_id }}" >{{ category.title}}</router-link></p>
                <p v-if="!(item.variants && item.variants.length>0)"><b>Цена</b>: {{item.price}} {{ item.currency}}</p>
                <p v-if="(item.variants && item.variants.length>0)"><b>Цена</b>: {{ item.variants[current_variant].price}} {{ item.currency}}</p>
                <div class="row alert alert-success" v-for="(option,option_key) in item.options" :key="option_key"
                     v-if="item.options.length>0">
                  <p><input type="checkbox" :value="true" @change="changeOptions(option_key)" v-model="custom_options[option_key]">{{ option.title}} <b>+{{ option.price }} {{ item.currency}}</b></p>

                </div>

                <button type="button" @click="addToCart()" class="btn btn-sm">В корзину</button>

                <div class="card alert alert-warning mt-2" v-if="is_error">
                  <p v-html="error_message"></p>
                </div>
                <div class="col-12 mt-3 ml-0 pl-0">
                  <UserCard   :user="item.user" route_name="user_page_items" />
                </div>
              </div>
            </div>

            <div class="mt-4">




            </div>


      <div class="col-12 second_section" v-if="reviews.length>0">
        <ReviewWidget :reviews="reviews"/>
      </div>
          <div class="row second_section">


            <editorjsrender class="ml-3" v-if="is_load " :blocks_json="item.content_json.blocks"></editorjsrender>
          </div>









    </div>

  </section>
</template>

<script>

import Api from "../../models/Api";
import Vue from "vue";
import Editorjsrender from "@/models/Editorjsrender";
import UserCard from "@/components/Custom/UserCard";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import VLazyImage from "v-lazy-image/v2";
import ReviewWidget from "@/components/widgets/ReviewWidget";




var Avatar = require('vue-avatar');


export default {
  name: 'Item',

  components: {
    'UserCard':UserCard,
    ReviewWidget,
    VLazyImage,
    'editorjsrender': Editorjsrender,
    LoadingBlock,
  },
  data() {
    return {
      "show_next_btn":false,
      "show_prev_btn":false,
      "current_pic":0,
      "current_variant":0,
      "category":null,
      "item":[],
      "custom_options":[],
      "custom_price":0,
      "is_load":false,
      "is_error":false,
      "error_message":"",
      "reviews":[],
      "image_url":"",
    }
  },
  mounted() {
    var last_id=this.$route.params.id;

    var app=this;
    app.image_url = Vue.config.IMAGE_URL;
    Api.loadItem_by_last_id(last_id,function(data){



      app.category=data.item.category;
      app.reviews=data.reviews;
      app.item=data.item;
      app.custom_price=data.item.price;
      if(app.item.variants && app.item.variants.length>0){
        app.custom_price=app.item.variants[0].price;
      }


      if(app.item.photos[1]){
        app.show_next_btn=true;
      }
      app.is_load=true;
    },function(){
      app.$router.push({name:'404'});
    })
  },
  methods: {

    showNextPic(type='plus'){
     var app=this;
     var current_pic=app.current_pic;
     if(type=="plus"){
       current_pic=current_pic+1;
     }else {
       current_pic=current_pic-1;
     }

     if(app.item.photos[current_pic]){
       app.current_pic=current_pic;
     }

     var nextPic=current_pic+1;
     var prevPic=current_pic-1;
      app.show_next_btn=false;
      app.show_prev_btn=false;
     if(app.item.photos[nextPic]){
       app.show_next_btn=true;
     }
      if(app.item.photos[prevPic]){
        app.show_prev_btn=true;
      }
    },
    changeOptions(key){
      var app=this;
      var custom_price=parseInt(app.item.price);
      if(app.item.options.length>0){
        app.item.options.forEach(function(item, i, arr) {

           if(app.custom_options[i]){
             custom_price+=parseInt(item.price);
             app.custom_price=custom_price;
           }
        });

      }
    },
    addToCart(){
      var app=this;

      var item={};

      var selected_variant=null;
      var selected_var=null;
      var item_price=app.item.price;
      if(app.item.variants && app.item.variants.length>0){

        selected_variant=app.current_variant;
        selected_var=app.item.variants[selected_variant];
        selected_var.id=selected_variant;
        item_price=selected_var.price;
        app.custom_price=item_price;
      }



      item.last_id=app.item.last_id;
      item.title=app.item.title;
      item.photos=app.item.photos;
      item.price=item_price;
      item.user=app.item.user;
      item.user_id=app.item.user_id;
      item.custom_price=app.custom_price;
      item.currency=app.item.currency;
      item.options=app.item.options;
      item.variant=selected_var;
      item.custom_options=app.custom_options;
      item.count=1;
      item.total_price=parseInt(item.custom_price)*item.count;


      var query_obj={};


      app.is_error=false;
      Api.addToCartFromItem(item,selected_variant,function(){
        app.$router.push({path: "/cart",query:query_obj});

        app.custom_options=[];

        app.custom_price=parseInt(app.item.price);

      },function(err){
        app.is_error=true;
        app.error_message=err;
      });

    }




  }
};
</script>
